import React, { useEffect, useRef, useState } from "react";
import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import Blog1 from "../images/comp/blog1.webp";
import Blog2 from "../images/comp/blog-img.webp";
import Blog3 from "../images/comp/blog-img.webp";
import User from "../images/user.png";

// Blog Data Array
const blogData = [
  {
    id: 1,
    img: Blog1,
    title: "How AI is Revolutionizing Mobile App Development",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
  {
    id: 2,
    img: Blog2,
    title: "Why UI/UX Design is the Backbone of Any Digital Product",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
  {
    id: 3,
    img: Blog3,
    title: "Choosing the Right Tech Stack for Your Web Project",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
  {
    id: 4,
    img: Blog1,
    title: "How AI is Revolutionizing Mobile App Development",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
  {
    id: 5,
    img: Blog2,
    title: "How AI is Revolutionizing Mobile App Development",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
  {
    id: 6,
    img: Blog3,
    title: "How AI is Revolutionizing Mobile App Development",
    desc: "AI is no longer just a buzzword—it's reshaping how we build and experience mobile apps. At Hope Web Solutions...",
    authorImg: User,
    author: "Ranold Jeff.",
    date: "May 4th, 2022",
    link: "/blog",
  },
];

const Blog = ({ showPagination = false }) => {
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Pagination logic
  const totalPages = Math.ceil(blogData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentBlogData = showPagination
    ? blogData.slice(startIndex, endIndex)
    : blogData;

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (!showPagination && swiperRef.current && !swiperInstanceRef.current) {
      swiperInstanceRef.current = new Swiper(swiperRef.current, {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 16 },
          650: { slidesPerView: 2, spaceBetween: 20 },
          900: { slidesPerView: 3, spaceBetween: 28 },
        },
      });
    }

    // Cleanup function
    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy();
        swiperInstanceRef.current = null;
      }
    };
  }, [showPagination]);

  return (
    <section className="planning-section services-section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-9 mb-4 mb-lg-0 position-relative text-center">
            <span className="about-label">Our Blog</span>
            <h2 className="title">Latest Post</h2>
          </div>
        </div>

        {showPagination ? (
          <>
            {/* Grid Layout with Pagination */}
            <div className="row pt-4">
              {currentBlogData.map((item) => (
                <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                  <div className="blog-card">
                    <Link to={`/blog-details/${item.id}`}>
                      <img
                        src={item.img}
                        alt={item.title}
                        className="blog-img"
                      />
                      <h3 className="blog-card-title">{item.title}</h3>
                      <p className="blog-card-desc">{item.desc}</p>

                      <div className="blog-card-meta">
                        <span className="blog-author">
                          <img
                            src={item.authorImg}
                            alt="Author"
                            className="blog-author-img"
                          />
                          {item.author}
                        </span>
                        <span className="blog-date">{item.date}</span>
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="row mt-5">
                <div className="col-12">
                  <nav aria-label="Blog pagination">
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Previous
                        </button>
                      </li>

                      {[...Array(totalPages)].map((_, index) => {
                        const page = index + 1;
                        return (
                          <li
                            key={page}
                            className={`page-item ${currentPage === page ? "active" : ""
                              }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(page)}
                            >
                              {page}
                            </button>
                          </li>
                        );
                      })}

                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            )}
          </>
        ) : (
          /* Swiper slider */
          <div className="swiper blogSwiper pt-4" ref={swiperRef}>
            <div className="swiper-wrapper">
              {blogData.map((item) => (
                <div className="swiper-slide blog-card" key={item.id}>
                  <Link to={`/blog-details/${item.id}`}>
                    <img src={item.img} alt={item.title} className="blog-img" />
                    <h3 className="blog-card-title">{item.title}</h3>
                    <p className="blog-card-desc">{item.desc}</p>

                    <div className="blog-card-meta">
                      <span className="blog-author">
                        <img
                          src={item.authorImg}
                          alt="Author"
                          className="blog-author-img"
                        />
                        {item.author}
                      </span>
                      <span className="blog-date">{item.date}</span>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
